// Locale barrel — thin re-export from ./locales.
// The full per-language content lives in /app/frontend/src/i18n/locales/*.js
// This file only exposes the aggregated `translations` object plus structural
// `planData` array (which is intentionally not localised).

export { translations } from './locales';
export { default } from './locales';

// Plan data is structural — not localised.
// SP1 = Einstiegs-Solution-Plan ab $100 (per client request re-added Feb 2026).
// VIP fields = Rabatt (Total) including VIP-Paket bonus of +1% / +2% / +3% for Folie 19.
export const planData = [
  { id: 'SP1', from: '$250',   carat: '0,10 – 0,29', monthly: '2,20%', total: '26,4%', vip1: '38,4%', vip2: '50,4%', vip3: '62,4%' },
  { id: 'SP2', from: '$1K',    carat: '0,30 – 0,59', monthly: '2,45%', total: '29,4%', vip1: '41,4%', vip2: '53,4%', vip3: '65,4%' },
  { id: 'SP3', from: '$2.5K',  carat: '0,60 – 0,79', monthly: '2,70%', total: '32,4%', vip1: '44,4%', vip2: '56,4%', vip3: '68,4%' },
  { id: 'SP4', from: '$5K',    carat: '0,80 – 0,99', monthly: '3,00%', total: '36,0%', vip1: '48,0%', vip2: '60,0%', vip3: '72,0%', recommended: true },
  { id: 'SP5', from: '$10K',   carat: '1,00 – 2,49', monthly: '3,10%', total: '37,2%', vip1: '49,2%', vip2: '61,2%', vip3: '73,2%' },
  { id: 'SP6', from: '$50K',   carat: '2,50 – 3,90', monthly: '3,20%', total: '38,4%', vip1: '50,4%', vip2: '62,4%', vip3: '74,4%' },
  { id: 'SP7', from: '$100K',  carat: '4,00', caratFrom: true, monthly: '3,30%', total: '39,6%', vip1: '51,6%', vip2: '63,6%', vip3: '75,6%' },
];
